import React from 'react'
import PropTypes from 'prop-types'

import playerImg from '@assets/images/placeholder/playerPagePlaceholder.svg'

import dynamic from 'next/dynamic'
import CustomLink from '@shared/components/customLink'
import { getImgURL } from '@shared-submodule/utils'
import { getMatchPlayers } from '@shared/libs/match-detail'

const MyImage = dynamic(() => import('@shared/components/myImage'))

export default function PlayerRoles({ styles, data, capData, playerData, teamA }) {
  const players = getMatchPlayers()
  const oSeo = players[data?.oPlayer?._id]?.oSeo
  const eTagStatus = players[data?.oPlayer?._id]?.eTagStatus
  const oPlayer = { ...data?.oPlayer, oSeo, eTagStatus }
  const sPlayerName = oPlayer?.sShortName || oPlayer?.sFirstName
  return (
    <>
      <div className={`${styles.player} mx-2 mx-sm-2 mx-xl-3 flex-shrink-0`}>
        <div className={`${styles.playerImg} mx-auto`}>
          <MyImage src={oPlayer?.oImg?.sUrl ? getImgURL(oPlayer?.oImg?.sUrl) : playerImg} alt="user" layout="responsive" width="40" height="40" />
        </div>
        <div className={`${styles.name} ${teamA === data?.oTeam?._id ? '' : styles.nameDark}`}>{oPlayer?.eTagStatus === 'a' ? (
          <CustomLink href={`/${oPlayer?.oSeo?.sSlug}`}><a>{sPlayerName}</a></CustomLink>
        ) : (<span>{sPlayerName}</span>)}</div>
        {data?._id === capData?.oCapFan?._id && (
          <div className={`${styles.tagHead} rounded-circle small-text`}>
            <span className={`${styles.tag} rounded-circle small-text`}>
              C
            </span>
          </div>
        )}
        {data?._id === capData?.oVCFan?._id && (
          <div className={`${styles.tagHead} rounded-circle small-text`}>
            <span className={`${styles.tag} rounded-circle small-text`}>
              VC
            </span>
          </div>
        )}
        {data?._id === capData?.oTPFan?._id && (
          <div className={`${styles.tagHead} rounded-circle small-text`}><span className={`${styles.tag} rounded-circle small-text`}>12</span></div>
        )}
        <p className={`${styles.rating} xsmall-text mt-1 mb-2 mb-sm-3`}>{data?.nRating}</p>
      </div>
    </>
  )
}

PlayerRoles.propTypes = {
  styles: PropTypes.any,
  data: PropTypes.object,
  capData: PropTypes.object,
  playerData: PropTypes.array,
  teamA: PropTypes.string
}
